import { __assign, __rest } from "tslib";
import 'reflect-metadata';
import DataTypes, { DataType } from './data_types';
import { ASSOCIATE_METADATA_MAP } from './constants';
function findType(tsType) {
    var BIGINT = DataTypes.BIGINT, INTEGER = DataTypes.INTEGER, DATE = DataTypes.DATE, STRING = DataTypes.STRING, BOOLEAN = DataTypes.BOOLEAN;
    switch (tsType) {
        case BigInt:
            return BIGINT;
        case Number:
            return INTEGER;
        case Date:
            return DATE;
        case String:
            return STRING;
        case Boolean:
            return BOOLEAN;
        default:
            throw new Error("unknown typescript type ".concat(tsType));
    }
}
export function Column(options) {
    if (options === void 0) { options = {}; }
    return function (target, propertyKey) {
        // target refers to model prototype, an internal instance of `Bone {}`
        if (options['prototype'] instanceof DataType || options instanceof DataType) {
            options = { type: options };
        }
        if (!('type' in options)) {
            var tsType = Reflect.getMetadata('design:type', target, propertyKey);
            options['type'] = findType(tsType);
        }
        // narrowing the type of options to ColumnOption
        if (!('type' in options))
            throw new Error("unknown column options ".concat(options));
        // target refers to model prototype, an internal instance of `Bone {}`
        var model = target.constructor;
        if (!model.hasOwnProperty('attributes') || !model.attributes) {
            Object.defineProperty(model, 'attributes', {
                value: __assign({}, model.attributes),
                writable: false,
                enumerable: false,
                configurable: true,
            });
        }
        var columnName = options.name, restOptions = __rest(options, ["name"]);
        model.attributes[propertyKey] = __assign(__assign({}, restOptions), { columnName: columnName });
    };
}
var hasMany = ASSOCIATE_METADATA_MAP.hasMany, hasOne = ASSOCIATE_METADATA_MAP.hasOne, belongsTo = ASSOCIATE_METADATA_MAP.belongsTo;
export function HasMany(options) {
    if (options === void 0) { options = {}; }
    return function (target, propertyKey) {
        var _a;
        var model = target.constructor;
        // it seems it's not possible to get the type of array element at runtime
        Reflect.defineMetadata(hasMany, __assign(__assign({}, Reflect.getMetadata(hasMany, model)), (_a = {}, _a[propertyKey] = options, _a)), model);
    };
}
export function HasOne(options) {
    if (options === void 0) { options = {}; }
    return function (target, propertyKey) {
        var _a;
        var model = target.constructor;
        if (options.className == null) {
            var tsType = Reflect.getMetadata('design:type', target, propertyKey);
            if (tsType.name !== 'Function')
                options.className = tsType.name;
        }
        Reflect.defineMetadata(hasOne, __assign(__assign({}, Reflect.getMetadata(hasOne, model)), (_a = {}, _a[propertyKey] = options, _a)), model);
    };
}
/**
 * design:type will be `Function { [native code] }` in following example
 *
 * @example
 * import type Foo from './foo';
 * class Bar extends Bone {
 *   @BelongsTo()
 *   foo?: Foo;
 * }
 */
export function BelongsTo(options) {
    if (options === void 0) { options = {}; }
    return function (target, propertyKey) {
        var _a;
        var model = target.constructor;
        if (options.className == null) {
            var tsType = Reflect.getMetadata('design:type', target, propertyKey);
            if (tsType.name !== 'Function')
                options.className = tsType.name;
        }
        Reflect.defineMetadata(belongsTo, __assign(__assign({}, Reflect.getMetadata(belongsTo, model)), (_a = {}, _a[propertyKey] = options, _a)), model);
    };
}
//# sourceMappingURL=decorators.js.map